import { Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import PREFIX from 'common/constants';

const classes = {
  boxContainer: `${PREFIX}-boxContainer`,
  notesContainerTitle: `${PREFIX}-notesContainerTitle`,
  notesContainerStatus: `${PREFIX}-notesContainerStatus`,
  addNote: `${PREFIX}-addNote`,
  notesContainerDetails: `${PREFIX}-notesContainerDetails`,
  notesNotAvialableContainerDetails: `${PREFIX}-notesNotAvialableContainerDetails`,
  expandIcon: `${PREFIX}-expandIcon`,
  notesEmpty: `${PREFIX}-notesEmpty`,
  notesEmptyBtn: `${PREFIX}-notesEmptyBtn`,
  notesEmptyBtnText: `${PREFIX}-notesEmptyBtnText`,
  note: `${PREFIX}-note`,
  noteHeaderText: `${PREFIX}-noteHeaderText`,
  noteDetails: `${PREFIX}-noteDetails`,
  noteDetailContent: `${PREFIX}-noteDetailContent`,
  noteFooter: `${PREFIX}-noteFooter`,
  noteEditContainer: `${PREFIX}-noteEditContainer`,
  noteEditInput: `${PREFIX}-noteEditInput`,
  noteEditButtonContainer: `${PREFIX}-noteEditButtonContainer`,
  noteCancelButton: `${PREFIX}-noteCancelButton`,
  noteEditButton: `${PREFIX}-noteEditButton`,
  actionIcons: `${PREFIX}-actionIcons`,
};

const StyledTheme = styled('div')(({ theme }) => ({
  [`& .${classes.boxContainer}`]: {
    border: `0.063rem solid ${theme.palette.grey[300]}`,
    padding: '0 0.5rem',
    width: 'auto',
    '& .MuiIconButton-edgeEnd': {
      marginRight: '0px !important',
    },
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  [`& .${classes.notesContainerTitle}`]: {
    fontSize: '0.875rem',
    fontWeight: 700,
    marginRight: '0.4rem',
  },

  [`& .${classes.notesContainerStatus}`]: {
    fontSize: '0.875rem',
  },

  [`& .${classes.addNote}`]: {
    color: theme.palette.primary.main,
    marginTop: '-6px',
  },

  [`& .${classes.notesContainerDetails}`]: {
    display: 'flex',
    justifyContent: 'left',
  },

  [`& .${classes.notesNotAvialableContainerDetails}`]: {
    display: 'flex',
    justifyContent: 'center',
  },

  [`& .${classes.expandIcon}`]: {
    '& .MuiIconButton-edgeEnd': {
      marginRight: '0px !important',
    },
  },

  [`& .${classes.notesEmpty}`]: {
    margin: '3rem 0',
    fontWeight: 700,
    color: theme.palette.grey?.[500] ?? '#9e9e9e',
  },

  [`& .${classes.notesEmptyBtn}`]: {
    margin: '3rem 0',
    '&:hover': {
      background: '#ffffff',
    },
  },

  [`& .${classes.notesEmptyBtnText}`]: {
    fontWeight: 700,
    color: theme.palette.grey?.[500] ?? '#9e9e9e',
  },

  [`& .${classes.note}`]: {
    width: '100%',
  },

  [`& .${classes.noteHeaderText}`]: {
    fontSize: '0.75rem',
    fontWeight: 700,
  },

  [`& .${classes.noteDetails}`]: {
    width: 'auto',
    whiteSpace: 'break-spaces',
    marginRight: '1.5rem',
  },

  [`& .${classes.noteDetailContent}`]: {
    fontSize: '0.85rem',
  },

  [`& .${classes.noteFooter}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    flexDirection: 'column',
    marginRight: '1.5rem',
  },

  [`& .${classes.noteEditContainer}`]: {
    margin: '0rem 1.5rem',
  },

  [`& .${classes.noteEditInput}`]: {
    width: '100%',
    height: '100%',
    padding: 0,
  },

  [`& .${classes.noteEditButtonContainer}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.5rem 0rem !important',
  },

  [`& .${classes.noteCancelButton}`]: {
    marginLeft: '0.5rem',
    padding: '0.2rem',
    fontWeight: 'normal',
    border: `1px solid ${theme.palette.grey[100]}`,
    color: theme.palette.grey[400],
  },

  [`& .${classes.noteEditButton}`]: {
    marginLeft: '0.5rem',
    padding: '0.2rem',
    fontWeight: 'normal',
  },

  [`& .${classes.actionIcons}`]: {
    width: '0.8em',
    height: '0.8em',
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  minWidth: '50px',
  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiInputBase-input': {
    fontSize: '0.875rem',
    fontWeight: 700,
    padding: '2px 4px',
  },
}));

export const StyledButton = styled(Button)(() => ({
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  font: 'inherit',
  color: 'inherit',
}));